<div
  [formGroup]="form"
  class="flex items-center justify-between w-full wrapper {{ classes }}"
  [ngClass]="getFormClasses()"
>
  <div class="flex flex-row">
    <input
      type="radio"
      class="checkbox mt-2"
      [checked]="checked"
      [name]="name"
      [tabIndex]="tabIndex"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.space)="toggleSelection($event)"
      (click)="toggleSelection($event)"
    />
    <label>{{ label | translate }}<ng-content *ngIf="!label"></ng-content></label>
    <ark-icon
      icon="system-tick"
      color="light"
      size="micro"
      class="checkbox-tick"
    ></ark-icon>
  </div>

  @if (showInfoBubble) {
    <ark-icon
      icon="system-info"
      size="small"
      class="cursor-pointer"
      (click)="onInfoClick($event)"
    ></ark-icon>
  }
</div>
<div
  class="error"
  *ngIf="formStates.error && errorMessage"
  [@dropdownAnimation]
>
  <span [innerHTML]="errorMessage"></span>
</div>
